module.exports = __webpack_public_path__ + "img/nav3.5d8daf1c.png";